import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Injector, inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { TokenStorageService } from '../services/authentication/token-storage.service';
import { SessionRefreshService } from '../services/authentication/session-refresh.service';

const NO_AUTH_URLS = [
  'amazonaws.com',
  's3.'
];

const withToken = (req: HttpRequest<unknown>, token: string): HttpRequest<unknown> =>
  req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

const shouldSkipAuth = (url: string): boolean => {
  return NO_AUTH_URLS.some(domain => url.includes(domain));
};

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenStorage = inject(TokenStorageService);
  // Résolu uniquement en cas d'expiration : l'intercepteur s'exécute aussi pendant la construction d'AwsService.
  const injector = inject(Injector);

  if (shouldSkipAuth(req.url)) {
    return next(req);
  }

  const idToken = tokenStorage.getIdToken();
  const token = idToken || localStorage.getItem('accessToken') || localStorage.getItem('token');

  if (!token) {
    return next(req);
  }

  return next(withToken(req, token)).pipe(
    catchError((error: unknown) => {
      const idTokenExpired = error instanceof HttpErrorResponse
        && error.status === 401
        && !!idToken
        && tokenStorage.isIdTokenExpired(idToken);

      if (!idTokenExpired) {
        return throwError(() => error);
      }

      // Rejoue la requête initiale avec le nouvel idToken (sans repasser par cet intercepteur).
      return injector.get(SessionRefreshService).askToRefresh().pipe(
        switchMap(newIdToken => next(withToken(req, newIdToken)))
      );
    })
  );
};
